import Seo from "utils/seo";

import { useRouter } from "next/router";
import Footer from "components/Footer";
import { Block, Section } from "/components/Layout";
import { useEffect } from "react";

const CalendlyBookingConfirmed = () => {
  const router = useRouter();

  const { event_type_name, event_start_time, event_end_time }: any = router.query;

  let startTimeHours: number | null = null;
  let startTimeMinutes: number | string | null = null;
  let endTimeHours: number | null = null;
  let endTimeMinutes: number | string | null = null;
  let date: string | null = null;

  if (event_start_time && event_end_time) {
    startTimeHours = new Date(event_start_time).getHours();
    startTimeMinutes = new Date(event_start_time).getMinutes() || "00";
    endTimeHours = new Date(event_end_time).getHours();
    endTimeMinutes = new Date(event_end_time).getMinutes() || "00";
    date = new Date(event_start_time).toJSON()?.split("T")[0];
  }

  useEffect(() => {
    //  Event snippet for Prøvesykling bestilt conversion page
    // @ts-ignore
    window?.gtag("event", "conversion", { send_to: "AW-317694363/k9fgCJH6zOMDEJvDvpcB" });
  }, []);

  return (
    <>
      <Seo page={{ title: "Booking confirmed" }} isFrontpage />
      <Section limitedWidthSmall center>
        <Block bottom={7}>
          <h1>Velkommen til å prøve en Whee!</h1>
        </Block>

        <p className="body-quote">Time for {event_type_name}</p>
        <p className="body-quote">
          {startTimeHours}:{startTimeMinutes} - {endTimeHours}:{endTimeMinutes}, {date}
        </p>
      </Section>
      <Footer />
    </>
  );
};

export default CalendlyBookingConfirmed;
